export class Employee {
  id?: string;
  firstName = "";
  lastName = "";
  roles: string[] = [];
  poolInfo = {
    enabled: false,
    status: "",
  };
}
